import MaterialPage from '_modules/material/views/MaterialPage.vue';
import MaterialList from '_modules/material/views/MaterialList.vue';
import Material from './Root.vue';


export default {
  path: 'materiais/',
  component: Material,
  name: 'admin-material',
  redirect: '/materiais/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-material-list',
      component: MaterialList,
    },
    {
      path: 'novo/',
      name: 'admin-material-new',
      component: MaterialPage,
    },
    {
      path: ':materialId',
      name: 'admin-material-edit',
      component: MaterialPage,
    },
  ],
};
